<template>
  <!--使用指南-->
  <div class="tiket-operating-guid">
    <MHeader title="优惠券使用指南"></MHeader>
    <ul class="content">
      <li class="item">
        <h3 class="item-title">一、 如何获取优惠券</h3>
        <p class="item-content">活动发放，“寺库”某些活动可免费在库会所获取纸质优惠券，用户可在所有库会所消费使用，也可在线上商城激活后使用</p>
      </li>
      <li class="item">
        <h3 class="item-title">二、 如何使用优惠劵</h3>
        <p class="item-content">1.选购完商品后，进入结算中心，APP端会自动匹配一张可使用的优惠券，若想选用其他优惠券或者不使用优惠券，在结算中心点击“优惠券”进入优惠券列表之后进行操作。</p>
        <p class="item-content">2.不论电子还是实体优惠劵每次只能使用一张订单，不可以使用多个订单。优惠券一旦使用，将无法退回，请在使用前斟酌确认。</p>
      </li>
      <li class="item">
        <h3 class="item-title">三、 查看优惠券</h3>
        <p class="item-content">1. “优惠券”在寺库购物时可充当现金使用，并且一张优惠券只能使用一个订单，不可以使用多个订单。优惠券不可兑换以及返现。</p>
        <p class="item-content">2、订单中商品金额必须满足一定条件时才可以使用优惠券，例如：消费金额2000-即可使用100元的优惠券，所下订单中商品金额需要在2000元以上才可以使用。每笔订单只能使用一张优惠券;</p>
      </li>
      <li class="item">
        <h3 class="item-title">四、 优惠券使用规则</h3>
        <p class="item-content">1.优惠政策、配送时间、支付方式等都有可能进行调整，请随时关注网站公布的最新信息。</p>
        <p class="item-content">2.使用优惠券支付的订单，发生退换货的订单，退款结算按照实际结算金额退款，优惠券不予退回和兑换。</p>
        <p class="item-content">3.活动发放优惠券均有详细使用细则，请务必按照活动页面细则使用。</p>
        <p class="item-content">4.优惠券不与其它特殊活动同时进行（满减活动如除礼券金额外仍满足满减条件可以享受）。</p>
        <p class="item-content">5.本规则由寺库寄卖依据国家相关法律法规及规章制度予以解释。</p>
      </li>
      <div class="item">
        <p class="item-content tips">注：寺库所有优惠券均无法购买黄金，美妆及海外站商品。美容护肤、个人护理、彩妆香氛、家电数码、生活小家电、厨房小家电、家具家装、母婴、生活方
          式、金银投资类商品和虚拟商品、特例品不可使用常规优惠券</p>
      </div>
    </ul>
  </div>
</template>

<script>
  import MHeader from '@/components/MHeader';

  export default {
    name: 'index',
    components: {
      MHeader
    }
  };
</script>

<style lang="scss" scoped>
.tiket-operating-guid {
  .content {
    padding: toRem(80) toRem(30) 0;
    .item {
      margin-bottom: toRem(80);
    }
    .item-title {
      height: toRem(42);
      line-height: toRem(42);
      font-size: toRem(30);
      margin-bottom: toRem(30);
      color: #1C1717;
      font-weight: 700;
    }
    .item-content {
      line-height: toRem(42);
      font-size: toRem(28);
      margin-bottom: toRem(30);
    }
    .tips {
      color: #E93B39;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OperatingGuide/index.vue